export default "__VITE_ASSET__b2e6fa1d__"